<template>
  <toolbar transparent fixed :logo="false">
    <template v-slot:right>
      <toolbar-bookmark-button class="mr-1" :page-id="pageId" />
      <v-link
        v-if="isAuthenticated"
        :to="`/me/workout/${workoutId}/sessions`"
        class="v-toolbar__button mr-1"
      >
        <v-icon icon="equalizer" />
      </v-link>
      <toolbar-share-button />
    </template>
  </toolbar>
</template>

<script>
import { mapGetters } from "vuex"

import Toolbar from "@/components/Toolbar"
import ToolbarShareButton from "@/components/toolbar/ShareButton"
import ToolbarBookmarkButton from "@/components/toolbar/BookmarkButton"

export default {
  components: {
    Toolbar,
    ToolbarShareButton,
    ToolbarBookmarkButton
  },

  props: {
    workoutId: { type: Number, required: true },
    pageId: { type: Number, required: true }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"])
  }
}
</script>
